import React from 'react';

import { PlacementCardWrapper } from './style';

const PlacementCard = ({
  cardsData,
  activePlacementIndex,
  selectPlacementOption
}) => {

  return (
    <PlacementCardWrapper>
      {cardsData.map((item, index) => (
        <div
          key={item.id}
          className={`item-wrapper ${activePlacementIndex === index ? 'active' : ''}`}
          onClick={() => selectPlacementOption(index)}
        >
          <div className='option-name-row'>
            <span className='radio-dot' />
            <p className='option-name'>{item.placementOption}</p>
          </div>
          <div className='fee-row'>
            <span className='fee-amount'>${item?.placementFee}</span>
            <span className='fee-label'>placement fee</span>
          </div>
          <div className='items'>
            <div className='item-field'>
              <p>{item.shipments}</p>
              <p>{item.shipments === 1 ? 'shipment' : 'shipments'}</p>
            </div>
            <div className='item-field'>
              <p>{item.units ?? '---'}</p>
              <p>units</p>
            </div>
          </div>
        </div>
      ))}
    </PlacementCardWrapper>
  );
};

export default PlacementCard;
